import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The guest shell for ticket pages reached without signing in. AppHeaderComponent carries wallet, profile
 * and logout chrome that an anonymous visitor has no session for, so the guest gets the brand and their
 * ticket number and nothing else.
 */
@Component({
  selector: 'app-public-ticket-header',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './public-ticket-header.component.html',
  styleUrl: './public-ticket-header.component.scss'
})
export class PublicTicketHeaderComponent {
  @Input() ticketCode?: string;
}
